import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { uuid } from "@ant-design/plots/es/utils";
import { Space, Tag, Typography } from "antd";
import {
  BlueFileIcon,
  CalendarIcon,
  DoubleYellowUSerIcon,
  FileIcon,
  MessageIcon,
  SendMessageBlueIcon,
  UserActiveIcon,
  UserIcon,
  UserInActiveIcon,
} from "assets/icons";
import { getIn, useFormik } from "formik";
import moment from "moment/moment";
import { setIsRefresh } from "stores/slices/layout";
// import moment from "moment/moment";
import {
  doDeleteBroadcast,
  doGetRecipientsDetailPage,
  doGetRecipientsFutureDetail,
} from "stores/slices/message";

import AppButton from "components/button";
import FormInput from "components/forms/components/formInput";
import AppTable from "components/table";

import styles from "../../styles.module.scss";
const MessageDetailForm = props => {
  const {
    messageDetail,
    onCancel,
    onDownload,
    isRecipient,
    loading,
    isFuture,
    setLoading,
    setIsview,
  } = props;

  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [searchParams, setSearchParams] = useState({
    sortDirection: "DESC",
    pageNumber: 1,
    pageSize: 10,
    statuses: ["CREATED", "DELIVERED", "FAIL", "READ", "PENDING"],
  });

  useEffect(() => {
    if (messageDetail) {
      setSearchParams({
        ...searchParams,
        messageId: messageDetail.messageId,
      });
    }
  }, [messageDetail]);

  const handleFilter = (selectedKeys, confirm) => {
    confirm();
  };

  const handleSearch = (selectedKeys, confirm) => {
    confirm();
  };

  const handleTableChange = (pagination, filters, sorter) => {
    let newSearchParam = {};
    filters.phoneNumber &&
      (newSearchParam = {
        ...newSearchParam,
        searchKey: filters.phoneNumber[0],
      });
    filters.status &&
      (newSearchParam = {
        ...newSearchParam,
        statuses:
          filters.status.indexOf("SENT") !== -1
            ? [...filters.status, "READ", "DELIVERED"]
            : [...filters.status],
      });
    !filters.status &&
      (newSearchParam = {
        ...newSearchParam,
        statuses: ["DELIVERED", "FAIL", "SENT", "READ", "CREATED", "PENDING"],
      });
    if (sorter && sorter.columnKey && sorter.order) {
      newSearchParam = {
        ...newSearchParam,
        sortDirection: sorter.order === "ascend" ? "ASC" : "DESC",
      };
    } else {
      newSearchParam = {
        ...newSearchParam,
        sortDirection: "DESC",
      };
    }

    newSearchParam = {
      ...newSearchParam,
      pageNumber: pagination.current || searchParams.pageNumber,
      pageSize: pagination.pageSize || searchParams.pageSize,
    };

    setSearchParams(newSearchParam);
  };

  const columns = [
    {
      title: t("message.contact"),
      width: 100,
      dataIndex: "phoneNumber",
      key: "phoneNumber",
      // sorter: true,
      isSearchable: true,
      searchPlaceholder:
        "Search by " + t("message.phoneNumber").toString().toLowerCase(),
      ellipsis: {
        showTitle: true,
      },
    },
    {
      title: t("message.status"),
      width: 100,
      dataIndex: "status",
      key: "status",
      // sorter: true,
      // isSearchable: true,
      ellipsis: {
        showTitle: true,
      },
      filters: isFuture
        ? null
        : [
            {
              text: t("message.created"),
              value: "CREATED",
            },
            {
              text: t("message.pending"),
              value: "PENDING",
            },
            {
              text: t("message.sent"),
              value: "SENT",
            },
            {
              text: t("message.fail"),
              value: "FAIL",
            },
          ],
      render: (_, record) => (
        <Tag
          color={
            record.status === "DELIVERED" || record.status === "READ"
              ? "#0E9154"
              : record.status === "CREATED"
              ? "#0059C6"
              : record.status === "PENDING"
              ? "#337ac9"
              : "#E01839"
          }
          bordered={false}
        >
          {record.status === "DELIVERED" || record.status === "READ"
            ? t("message.sent")
            : record.status === "CREATED"
            ? t("message.created")
            : record.status === "PENDING"
            ? t("message.pending")
            : t("message.fail")}
        </Tag>
      ),
    },
  ];
  const handleFormatDateLocale = (date, timezone) => {
    const browserLocale = navigator.language;
    let dateLocale;
    if (date) {
      dateLocale = moment(date)
        .tz(timezone || moment.tz.guess())
        .locale(browserLocale);
      return `${dateLocale.format("YYYY-MM-DD")} ${dateLocale.format("LT")}`;
    }
  };

  useEffect(() => {
    if (messageDetail) {
      if (isRecipient) {
        const newValues = {
          ...messageDetail,
          sendTime: `${handleFormatDateLocale(
            messageDetail.sendTime,
            messageDetail.timezone
          )} (${messageDetail.timezone})`,
          sender:
            messageDetail.sender && messageDetail.sender.trim() !== ""
              ? messageDetail.sender
              : messageDetail.fromUserEmail,
        };
        setValues(newValues);
      }
    }
  }, [messageDetail]);

  const handleDelete = async selectedMessage => {
    setLoading(true);
    const request = {
      id: selectedMessage.messageId,
    };
    const { payload } = await dispatch(doDeleteBroadcast(request));
    dispatch(setIsRefresh(uuid()));
    setLoading(false);
    if (payload && payload === "ok") {
      setIsview(false);
    }
  };

  const handleForm = useFormik({
    initialValues: {
      address: "",
      sendTime: "",
      sender: "",
      message: "",
    },
  });
  const { values, setValues } = handleForm;
  const infoInputItems = [
    {
      type: "text",
      key: "address",
      label: t("message.from"),
      icon: <FileIcon />,
      span: 24,
      style: {
        marginBottom: 10,
      },
      readOnly: true,
    },
    {
      type: "text",
      key: "sendTime",
      label: t("message.sendDateAndTime"),
      icon: <CalendarIcon />,
      span: 24,
      style: {
        marginBottom: 10,
      },
      readOnly: true,
    },
    {
      type: "text",
      key: "sender",
      label: t("message.sender"),
      icon: <UserIcon />,
      span: 24,
      style: {
        marginBottom: 10,
      },
      readOnly: true,
      config: {
        isLeft: true,
      },
    },
    {
      type: "text",
      key: "message",
      label: t("message.message"),
      icon: <MessageIcon />,
      span: 24,
      style: {
        marginBottom: 10,
      },
      config: {
        isTooltip: true,
        isLeft: true,
      },
      readOnly: true,
    },
  ];

  const handleReviewForm = useFormik({
    initialValues: {
      messageType: "",
      message: "",
    },
  });

  const reviewInputItems = [
    {
      type: "text",
      key: "messageType",
      label: t("message.messageType"),
      icon: <MessageIcon />,
      span: 24,
      style: {
        marginBottom: 10,
        width: "100%",
      },
      config: {
        isTooltip: true,
        width: "100%",
        showCount: true,
        maxLength: 255,
      },
      disabled: true,
      // readOnly: true,
    },
    {
      type: "textarea",
      key: "message",
      label: t("message.message"),
      icon: <MessageIcon />,
      span: 24,
      style: {
        marginBottom: 10,
        width: "100%",
      },
      config: {
        isTooltip: true,
        width: "100%",
        showCount: true,
        maxLength: 5000,
      },
      // disabled: true,
      // readOnly: true,
    },
  ];

  useEffect(() => {
    if (messageDetail && !isRecipient) {
      handleReviewForm.setValues({
        message: messageDetail.message,
        messageType: messageDetail.messageType,
      });
    }
  }, [messageDetail]);
  return (
    <div style={{ width: "100%" }}>
      <Space direction={"vertical"} style={{ width: "100%" }}>
        {isRecipient && (
          <>
            <Space style={{ width: "100%" }}>
              <FormInput
                items={infoInputItems.map(item => {
                  item.label = t(item.label);
                  if (item.key) {
                    item.value = getIn(values, item.key);
                  }
                  return { ...item };
                })}
                form={handleForm}
              />
            </Space>
            <Space
              style={{
                width: "100%",
                display: "flex",
                justifyContent: "space-between",
                flexDirection: "row",
                flexWrap: "wrap",
              }}
            >
              <Space
                direction={"vertical"}
                style={{
                  border: "1px solid #DEE1E5",
                  borderRadius: "10px",
                  alignItems: "flex-start",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                  width: 150,
                  height: 150,
                  marginBottom: 10,
                }}
              >
                <DoubleYellowUSerIcon />
                <div>{t("message.recipients")}</div>
                <div style={{ fontWeight: "bold" }}>
                  {messageDetail.numberOfRecipients}
                </div>
              </Space>
              <Space
                direction={"vertical"}
                style={{
                  border: "1px solid #DEE1E5",
                  borderRadius: "10px",
                  alignItems: "flex-start",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                  height: 150,
                  width: 150,
                  marginBottom: 10,
                }}
              >
                <SendMessageBlueIcon />
                <div>{t("message.sent")}</div>
                <div style={{ fontWeight: "bold" }}>
                  {messageDetail.numberOfSentMessages}
                </div>
              </Space>
              <Space
                direction={"vertical"}
                style={{
                  border: "1px solid #DEE1E5",
                  borderRadius: "10px",
                  alignItems: "flex-start",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                  height: 150,
                  width: 150,
                  marginBottom: 10,
                }}
              >
                <BlueFileIcon />
                <div>{t("message.failSends")}</div>
                <div style={{ fontWeight: "bold" }}>
                  {messageDetail.numberOfFailSentMessages}
                </div>
              </Space>
              <Space
                direction={"vertical"}
                style={{
                  border: "1px solid #DEE1E5",
                  borderRadius: "10px",
                  alignItems: "flex-start",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                  height: 150,
                  width: 150,
                  marginBottom: 10,
                }}
              >
                <UserActiveIcon />
                <div>{t("message.invalidNumbers")}</div>
                <div style={{ fontWeight: "bold" }}>
                  {messageDetail.numberOfInvalidNumbers}
                </div>
              </Space>
              <Space
                direction={"vertical"}
                style={{
                  border: "1px solid #DEE1E5",
                  borderRadius: "10px",
                  alignItems: "flex-start",
                  padding: "10px",
                  backgroundColor: "#FFFFFF",
                  height: 150,
                  width: 150,
                  marginBottom: 10,
                }}
              >
                <UserInActiveIcon />
                <div>{t("message.duplicateNumbers")}</div>
                <div style={{ fontWeight: "bold" }}>
                  {messageDetail.numberOfDuplicateNumbers}
                </div>
              </Space>
            </Space>
            <Space direction={"vertical"} style={{ width: "100%" }}>
              <Typography
                className={styles.labelGroupHeader}
                style={{
                  marginBottom: 16,
                  width: "100%",
                }}
              >
                {t("message.recipients")}
              </Typography>
              <div style={{ width: "100%" }}>
                <AppTable
                  searchParam={searchParams}
                  api={
                    isFuture
                      ? doGetRecipientsFutureDetail({
                          ...searchParams,
                          messageId: messageDetail.messageId,
                        })
                      : !loading
                      ? doGetRecipientsDetailPage({
                          ...searchParams,
                          messageId: messageDetail.messageId,
                        })
                      : null
                  }
                  handleTableChange={handleTableChange}
                  setSearchParam={setSearchParams}
                  handleSearch={handleSearch}
                  handleFilter={handleFilter}
                  columns={columns}
                  scroll={1200}
                  pageSizeOptions={[10, 50, 100, 250, 500]}
                />
              </div>
            </Space>
          </>
        )}
        {!isRecipient && (
          <Space style={{ width: "100%", display: "block" }}>
            <FormInput
              items={reviewInputItems.map(item => {
                item.label = t(item.label);
                if (item.key) {
                  item.value = getIn(handleReviewForm.values, item.key);
                }
                return { ...item };
              })}
              form={handleReviewForm}
              layout={"vertical"}
            />
          </Space>
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "end",
            marginTop: "20px",
          }}
        >
          <AppButton
            label={t("button.delete")}
            color={"red"}
            // loading={loading}
            type="button"
            onClick={() => {
              handleDelete(messageDetail);
            }}
            size={"medium"}
            danger={true}
            className={"cancelButton"}
            loading={loading}
          />
          <AppButton
            label={t("button.close")}
            color={"grey"}
            loading={loading}
            type="button"
            onClick={() => {
              onCancel();
            }}
            size={"medium"}
            className={"cancelButton"}
          />
          {isRecipient && (
            <AppButton
              label={t("button.download")}
              color={"blue"}
              loading={loading}
              type="submit"
              onClick={() => {
                onDownload();
              }}
              size={"medium"}
            />
          )}
        </div>
      </Space>
    </div>
  );
};

export default MessageDetailForm;
